"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = exports.normalize = exports.toObject = exports.validStorage = exports.InStorageCacheError = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var InStorageCacheError =
/*#__PURE__*/
function (_Error) {
  _inherits(InStorageCacheError, _Error);

  function InStorageCacheError(message) {
    var _getPrototypeOf2;

    _classCallCheck(this, InStorageCacheError);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(InStorageCacheError)).call.apply(_getPrototypeOf2, [this, "[InStorageCacheError] ".concat(message)].concat(args)));
  }

  return InStorageCacheError;
}(_wrapNativeSuper(Error));

exports.InStorageCacheError = InStorageCacheError;

var validStorage = function validStorage(storage) {
  return Boolean(storage && storage.getItem && storage.setItem && storage.removeItem && storage.clear);
};
/**
 * Iterates each key of the storage and execute the callback on it.
 *
 * @param {Object} storage The storage instance.
 * @param {Function} callback The iteration callback.
 */


exports.validStorage = validStorage;

var iterate = function iterate(storage, callback) {
  for (var i = 0; i < storage.length; ++i) {
    callback(storage.key(i));
  }
};
/**
 * Creates a plain object from all the storage's persisted data.
 *
 * @param {Object} storage The storage instance.
 * @param {Function} denormalize Method of denormalizing the retrieved resource.
 * @param {String} prefix The storage persisting key prefix.
 */


var toObject = function toObject(storage) {
  var denormalize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (value) {
    return value;
  };
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var object = {};
  iterate(storage, function (key) {
    if (key.indexOf(prefix) === 0) {
      object[key.slice(prefix.length)] = denormalize(storage.getItem(key));
    }
  });
  return object;
};

exports.toObject = toObject;
var normalize = JSON.stringify;
exports.normalize = normalize;
var denormalize = JSON.parse;
exports.denormalize = denormalize;